/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tourhelp_SectionInputs */

const en_tourhelp_section = /** @type {(inputs: Tourhelp_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tours for this page`)
};

/** @type {(inputs: Tourhelp_SectionInputs) => LocalizedString} */
const ar_tourhelp_section = en_tourhelp_section;

/** @type {(inputs: Tourhelp_SectionInputs) => LocalizedString} */
const he_tourhelp_section = en_tourhelp_section;

/** @type {(inputs: Tourhelp_SectionInputs) => LocalizedString} */
const ur_tourhelp_section = en_tourhelp_section;

/** @type {(inputs: Tourhelp_SectionInputs) => LocalizedString} */
const es_tourhelp_section = en_tourhelp_section;

/** @type {(inputs: Tourhelp_SectionInputs) => LocalizedString} */
const fr_tourhelp_section = en_tourhelp_section;

/** @type {(inputs: Tourhelp_SectionInputs) => LocalizedString} */
const de_tourhelp_section = en_tourhelp_section;

/** @type {(inputs: Tourhelp_SectionInputs) => LocalizedString} */
const pt_tourhelp_section = en_tourhelp_section;

/** @type {(inputs: Tourhelp_SectionInputs) => LocalizedString} */
const hi_tourhelp_section = en_tourhelp_section;

/** @type {(inputs: Tourhelp_SectionInputs) => LocalizedString} */
const bn_tourhelp_section = en_tourhelp_section;

/**
* | output |
* | --- |
* | "Tours for this page" |
*
* @param {Tourhelp_SectionInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const tourhelp_section = /** @type {((inputs?: Tourhelp_SectionInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tourhelp_SectionInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_tourhelp_section(inputs)
	if (locale === "he") return he_tourhelp_section(inputs)
	if (locale === "ur") return ur_tourhelp_section(inputs)
	if (locale === "es") return es_tourhelp_section(inputs)
	if (locale === "fr") return fr_tourhelp_section(inputs)
	if (locale === "de") return de_tourhelp_section(inputs)
	if (locale === "pt") return pt_tourhelp_section(inputs)
	if (locale === "hi") return hi_tourhelp_section(inputs)
	if (locale === "bn") return bn_tourhelp_section(inputs)
	return /** @type {LocalizedString} */ ("Tours for this page")
});